<template>
  <div :style="{ backgroundImage: `url(${item.img}` }">
    <p>
      <b
        ><span>{{ timeCn }}</span></b
      >
      <b
        ><span>{{ getSilkBannerDescList(item.silkBannerDesc)[0] }}</span></b
      >
      <b
        ><span>{{ getSilkBannerDescList(item.silkBannerDesc)[1] }}</span></b
      >
      <b
        ><span v-if="workerName">赠.. {{ workerName }}</span></b
      >
    </p>
  </div>
</template>
<script>
export default {
  props: {
    item: {
      type: Object,
      default: {}
    },
    timeCn: {
      type: String,
      default: ''
    },
    workerName: {
      type: String,
      default: ''
    }
  },
  methods: {
    getSilkBannerDescList(text) {
      return text ? text.split(' ') : []
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/assets/css/mixin';
div {
  background-repeat: no-repeat;
  background-size: 100% auto;
  width: 100%;
  height: rem(420px);
  margin: 0 auto;
  padding: rem(50px) rem(60px);
  padding-bottom: rem(90px);
  p {
    font-family: '方正';
    height: 100%;
    display: flex;
    b {
      writing-mode: vertical-rl;
      flex: 1;
      height: 100%;
      display: flex;
      align-items: center;
      font-size: rem(34px);
      color: #ffffff;
      letter-spacing: 0.8em;
      padding-top: rem(30px);
      &:nth-child(1) {
        justify-content: flex-end;
      }
      &:first-child {
        padding-bottom: rem(20px);
      }
      &:last-child {
        span {
          position: relative;
        }
      }
      &:first-child,
      &:last-child {
        font-size: rem(20px);
        padding-top: 0;
        letter-spacing: 1px;
        @include ellicpsis;
      }
    }
  }
}
</style>
